import { Link } from 'react-router-dom';

const footerLinks = {
  categories: [
    { label: '国产剧', href: '/category/chinese' },
    { label: '韩剧', href: '/category/korean' },
    { label: '美剧', href: '/category/american' },
    { label: '日剧', href: '/category/japanese' },
    { label: '动漫', href: '/category/anime' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#brand' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
  support: [
    { label: '常见问题', href: '/about#faq' },
    { label: '使用帮助', href: '/about#help' },
    { label: '意见反馈', href: '/about#contact' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-10 h-10 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-movie-2-line text-white text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <span className="text-xl font-heading text-white">
                窝窝影院
              </span>
            </Link>
            <p className="text-sm text-foreground-400 leading-relaxed">
              窝窝影院为您提供电视剧全集免费在线观看，最新热播剧集大全，高清不缓冲流畅播放，无广告全免费，每日更新热门电视剧，追剧首选平台。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-white text-sm w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">剧集分类</h4>
            <ul className="space-y-2.5">
              {footerLinks.categories.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-white mb-4">帮助支持</h4>
            <ul className="space-y-2.5">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 窝窝影院 wowocinema.com - 版权所有
            </p>
            <p className="text-xs text-foreground-500">
              本站所有资源均来自网络，仅供学习交流使用
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}